<template>
  <MobileMaterial :material="material" v-if="mode === 'mobile'">
    <slot>
      {{material.title}}
    </slot>
  </MobileMaterial>
  <ScreenMaterial :material="material" v-else>
    <slot>
      {{material.title}}
    </slot>
  </ScreenMaterial>
</template>

<script>
import MobileMaterial from './mobile/material'
import ScreenMaterial from './screen/material'
export default {
  name: 'ICMaterial',
  components: {
    MobileMaterial,
    ScreenMaterial
  },
  inject: ['mode'],
  props: {
    material: {
      type: Object,
      require: true
    },
  }
}
</script>
<style>
.material {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  display: flex !important;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: blue;
  color: #fff;
}
</style>
